import { Card, Container } from 'reactstrap';
import StudentFileTabs from './parts/StudentFileTabs';

const UpdateStudentFile = () => {
  return (
    <Container fluid>
      <Card className="p-4 mt-2 mx-3">
        <StudentFileTabs />
      </Card>
    </Container>
  );
};

export default UpdateStudentFile;
